import React, { createContext, useContext } from 'react';
import { useAudioRecording } from '../hooks/useAudioRecording.js';

const FlashFonicContext = createContext(null);

export const FlashFonicProvider = ({
    children,
    isDevMode,
    usage,
    duration,
    isSafari,
    setNotification,
    generateFlashcardRequest,
}) => {
    const controls = useAudioRecording({
        isDevMode,
        usage,
        duration,
        isSafari,
        setNotification,
        generateFlashcardRequest,
    });
    return (
        <FlashFonicContext.Provider value={controls}>
            {children}
        </FlashFonicContext.Provider>
    );
};

export const useFlashFonic = () => {
    const ctx = useContext(FlashFonicContext);
    if (!ctx) throw new Error('useFlashFonic must be used within FlashFonicProvider');
    return ctx;
};


